<div class="flag__content">
	<span *ngIf="!hasSSR" 
		class="no-ssr" 
		[pTooltip]="tooltipTitle.hasSSR"
        tooltipStyleClass="custom-sm-tooltip"
        tooltipPosition="top">
		<i class="fas fa-flag"></i>
	</span>
	<span *ngIf="cellValue.guaranteeState > 0" class="cvGuarantee"
		[pTooltip]="tooltipTitle.cvGuarantee"
        tooltipStyleClass="custom-sm-tooltip"
        tooltipPosition="top">
		<i class="fas fa-award" [ngClass]="{
			'pending': cellValue.guaranteeState === 1,
			'elegible': cellValue.guaranteeState === 2,
			'not-elegible': cellValue.guaranteeState === 3
		}"></i>
	</span>
</div>
